import React from 'react';
import {TableCell, TableSortLabel} from '@material-ui/core';
import {ITitle} from './type';

const Title = ({handleClick, orderBy}: ITitle) => {
    const click = () => {
        handleClick();
    };

    return (
        <TableCell
            style={{width: '50px', verticalAlign: 'center', paddingTop: '20px'}}
            onClick={click}>
            <TableSortLabel
                active={true}
                direction={!orderBy ? 'desc' : orderBy}
            />
        </TableCell>
    );
};

export default Title;
